export var EWalletActions;
(function (EWalletActions) {
    EWalletActions["CLEAR_LOCAL_STORAGE"] = "CLEAR_LOCAL_STORAGE";
    EWalletActions["SET_ERROR"] = "SET_ERROR";
    EWalletActions["SET_CACHE"] = "SET_CACHE";
    EWalletActions["SET_WALLET_DETAILS"] = "SET_WALLET_DETAILS";
    EWalletActions["SET_BALANCE"] = "SET_BALANCE";
    EWalletActions["SET_BATCH"] = "SET_BATCH";
    EWalletActions["SET_INITIALIZED"] = "SET_INITIALIZED";
    EWalletActions["SET_PERFORMING_SYNC"] = "SET_PERFORMING_SYNC";
    EWalletActions["SET_ACTIVE_WALLET"] = "SET_ACTIVE_WALLET";
    EWalletActions["SET_DAPP_CONNECTOR"] = "SET_DAPP_CONNECTOR";
})(EWalletActions || (EWalletActions = {}));
const setBatch = (state, dispatch) => dispatch({ type: EWalletActions.SET_BATCH, payload: { state } });
const setCache = (cache, dispatch) => dispatch({ type: EWalletActions.SET_CACHE, payload: { cache } });
const setError = (error, dispatch) => dispatch({ type: EWalletActions.SET_ERROR, payload: { error } });
const setActiveWallet = (activeWallet, dispatch) => dispatch({
    type: EWalletActions.SET_ACTIVE_WALLET,
    payload: { activeWallet },
});
const setWalletDetails = (details, dispatch) => dispatch({ type: EWalletActions.SET_WALLET_DETAILS, payload: { details } });
const setInitialized = (initialized, dispatch) => dispatch({ type: EWalletActions.SET_INITIALIZED, payload: { initialized } });
const setBalance = (balance, dispatch) => dispatch({ type: EWalletActions.SET_BALANCE, payload: { balance } });
const setDappConnector = (dAppConnector, dispatch) => dispatch({
    type: EWalletActions.SET_DAPP_CONNECTOR,
    payload: { dAppConnector },
});
const logout = async (dispatch) => dispatch({ type: EWalletActions.CLEAR_LOCAL_STORAGE });
export const Actions = {
    setCache,
    setBatch,
    setError,
    setBalance,
    setWalletDetails,
    setInitialized,
    setActiveWallet,
    setDappConnector,
    logout,
};
//# sourceMappingURL=actions.js.map